<script setup lang="ts">
import { useSeoHead } from '~/composables/useSeoHead'

definePageMeta({
  hideDefaultTopNav: true,
  newsCategory: 'bit_yaowen',
  validate: (route) => {
    const page = Array.isArray(route.params.page) ? route.params.page[0] : route.params.page
    return /^\d+$/.test(String(page || '')) && Number(page) >= 2
  },
})

const route = useRoute()
const { t } = useAppI18n()
/** 从分页路由参数获取当前页码。 */
const currentPage = computed(() => {
  const page = Number(Array.isArray(route.params.page) ? route.params.page[0] : route.params.page)

  return Number.isFinite(page) && page > 0 ? Math.trunc(page) : 1
})

const pageTitle = computed(() => t('85727', [currentPage.value]))
useSeoHead({
  title: pageTitle,
  description: () => t('85735', [currentPage.value]),
  keywords: computed(() => pageTitle.value.replace(/\s*\|\s*WikiBit\s*$/i, '')),
})
</script>

<template>
  <NewsListContent />
</template>
